<template>
  <div>
    <main-slider />
    <full-menu />
    <div class="main-page-content">
      <template v-if="manufacturerFilter">
        <games-list-wrapper :title="t('allGames')" />
      </template>

      <template v-else>
        <games-slider-sub-group
          v-if="showBonusesGames"
          group-prop="promo-games"
          :title-prop="t('promoGames')"
          :all-link="{ name: 'BonusGames' }"
          :max-row="1"
        />

        <games-slider-sub-group
          v-for="(slider, index) in firstSubgroupForSlider"
          :key="index"
          :group-prop="slider.group"
          :subgroup-code="slider.subgroup"
          :title-prop="t(slider.title)"
          :all-link="slider.link"
          :max-row="2"
        />
        <games-slider-sub-group group-prop="exclusive" :title-prop="$t('Exclusive')" :max-row="1" />
        <event-slider v-if="showEventSlider" />
        <games-slider-sub-group
          v-for="(slider, index) in subgroupsForSliderNoIntersection"
          :key="index"
          :group-prop="slider.group"
          :subgroup-code="slider.subgroup"
          :title-prop="t(slider.title)"
          :all-link="slider.link"
          :max-row="2"
        />
        <providers-slider />
        <games-slider-sub-group
          v-for="(slider, index) in subgroupsForSliderIntersection"
          :key="index"
          :group-prop="slider.group"
          :subgroup-code="slider.subgroup"
          :title-prop="t(slider.title)"
          :all-link="slider.link"
          :max-row="2"
        />
      </template>
      <promotions-slider />
      <competition-main-page />
    </div>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import GamesListWrapper from 'components/games/GamesListWrapper'
import MainSlider from 'components/banners/MainSlider'
import PromotionsSlider from 'components/home/PromotionsSlider'
import FullMenu from 'components/layouts/FullMenu'
// import ldJson from "src/seo/home";
import GamesSliderSubGroup from 'components/games/GamesSliderSubGroup'
import { HOT_SLIDERS } from 'src/common/config'
import ProvidersSlider from 'components/providers/ProvidersSlider.vue'
import { getConfig } from 'src/configs'
import { useUserBonusesStore } from 'src/stores/user/bonuses'

const CompetitionMainPage = defineAsyncComponent(() => import('components/pages/home/CompetitionMainPage.vue'))
const EventSlider = defineAsyncComponent(() => import('components/banners/EventSlider.vue'))

const config = getConfig()

const route = useRoute()
const { t } = useI18n()
const userBonusesStore = useUserBonusesStore()

const COUNT_PERSISTENT = 2
const COUNT_FIRST_PERSISTENT = 1

const showBonusesGames = computed(() => userBonusesStore.showBonusesGames)

const showEventSlider = computed(() => config.showEventSlider)
const manufacturerFilter = computed(() => route.query.manufacturer)
const firstSubgroupForSlider = computed(() => [...HOT_SLIDERS].slice(0, COUNT_FIRST_PERSISTENT))
const subgroupsForSliderIntersection = computed(() => [...HOT_SLIDERS].slice(COUNT_PERSISTENT))
const subgroupsForSliderNoIntersection = computed(() =>
  [...HOT_SLIDERS].slice(COUNT_FIRST_PERSISTENT, COUNT_PERSISTENT)
)
</script>
